import { VcfDomain } from 'pcs-domain';

export class PredicateHelper {
    static evaluatePredicate(predicate: VcfDomain.Predicate, context: any[]): boolean {
        const results = predicate?.conditions?.map((condition: any) => {
            // Check if this is a nested Predicate by checking for 'operator' AND 'conditions' properties
            // A Predicate has operator ('AND'/'OR') and conditions array
            // A Condition has key, value, and operation ('EQUALS'/'NOT_EQUALS')
            if ('operator' in condition && 'conditions' in condition) {
                // Recursively evaluate nested predicate
                return PredicateHelper.evaluatePredicate(condition, context);
            }
            
            // Otherwise treat as a Condition (has 'key' property or 'operation' property)
            if ('key' in condition && condition.key) {
                const contextItem = context.find(c => condition.key in c);
                if (!contextItem) {
                    return false; // Key not found in context
                }
                const actualValue = contextItem[condition.key];
                
                // Handle both 'operation' and 'operator' for backward compatibility
                // Some data might use 'operator' instead of 'operation' at condition level
                const operationType = condition.operation || condition.operator;
                
                switch (operationType) {
                    case 'EQUALS':
                        return actualValue === condition.value;
                    case 'NOT_EQUALS':
                        return actualValue !== condition.value;
                    default:
                        throw new Error(`Unsupported operation: ${operationType}`);
                }
            }
            return false;
        });

        if (predicate.operator === 'AND') {
            return results?.every(Boolean) || false;
        } else if (predicate.operator === 'OR') {
            return results?.some(Boolean) || false;
        } else {
            throw new Error(`Unsupported operator: ${predicate.operator}`);
        }
    }
}